// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Set property spacing for any arbitrary property
 *
 * @param \$property (string) - string name of the property to be set
 * @param \$sizesList (list) - list of values to set for the given property
 *    Values in \$sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')
 *
 * Example usage: setPropertySpacing('padding', ('sm', 'lg'));
 *    -> renders to: { padding: 8px 32px; }
 */
/**
 * Build CSS Grid
 *
 * @param \$grid-type (string) - name of the grid type
 * @param \$args (string) - values to be used for grid type
 *    Functions or string allowed - repeat(), '1fr 1fr 250px'
 * @param \$row-gap, \$column-gap (string) - string value for grid-gap
 *
 * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');
 *    -> renders to: { 
                      display: grid; 
                      grid-template-columns: 1fr 3fr 1fr;
                      row-gap: 24px;
                      column-gap: 8px;
                    }
 */
.robinhood-banner {
  width: 100%;
  max-width: 425px;
  background: #fffbee;
  border-radius: 8px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);
  padding: 16px;
  margin-bottom: 16px;
  margin-top: -20px;
}
.robinhood-banner__content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.robinhood-banner__title {
  color: var(--Secondary-Slate, #5d5d5e);
  font-family: "Rh-phonic";
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}
.robinhood-banner__icon {
  width: 14px;
  height: 18px;
  margin-left: 0;
  vertical-align: middle;
  position: relative;
  top: -1px;
}
.robinhood-banner__gold {
  color: #000000;
}
.robinhood-banner__description {
  font-size: 14px;
  line-height: 1.4;
  color: #333333;
  font-family: "poppins", -apple-system, BlinkMacSystemFont, sans-serif;
  margin-top: 2px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.1px;
}
.robinhood-banner__highlight {
  font-weight: 600;
}
.robinhood-banner__learn-more {
  font-size: 14px;
  font-weight: 600;
  color: #000;
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  padding-left: 6px;
}
.robinhood-banner__learn-more:hover {
  text-decoration: underline;
}
.robinhood-banner__learn-more:focus {
  outline: none;
}
.robinhood-banner__arrow {
  margin-left: 4px;
  font-size: 18px;
}
@media (min-width: 950px) {
  .robinhood-banner {
    padding: 20px;
    max-width: none;
  }
  .robinhood-banner__content {
    gap: 12px;
  }
  .robinhood-banner__title {
    font-size: 14px;
    line-height: 24px;
  }
  .robinhood-banner__gold {
    font-size: 14px;
  }
  .robinhood-banner__icon {
    width: 16px;
    height: 20px;
  }
  .robinhood-banner__description {
    font-size: 16px;
    letter-spacing: -0.2px;
  }
}
@media (min-width: 1100px) {
  .robinhood-banner {
    padding: 24px;
  }
  .robinhood-banner__content {
    gap: 14px;
  }
  .robinhood-banner__title {
    font-size: 15px;
  }
  .robinhood-banner__gold {
    font-size: 15px;
  }
  .robinhood-banner__description {
    font-size: 18px;
    line-height: 170%;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/dist/bankrate/robinhood-banner.css"],"names":[],"mappings":"AAAA;;;;;;;;;EASE;AACF;;;;;;;;;;;;;;;EAeE;AACF;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,sCAAsC;EACtC,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qEAAqE;EACrE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AAEA;EACE;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;IACf,sBAAsB;EACxB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["/**\n * Set property spacing for any arbitrary property\n *\n * @param $property (string) - string name of the property to be set\n * @param $sizesList (list) - list of values to set for the given property\n *    Values in $sizesList can be strings or numbers: i.e. ('sm', 0, 'lg')\n *\n * Example usage: setPropertySpacing('padding', ('sm', 'lg'));\n *    -> renders to: { padding: 8px 32px; }\n */\n/**\n * Build CSS Grid\n *\n * @param $grid-type (string) - name of the grid type\n * @param $args (string) - values to be used for grid type\n *    Functions or string allowed - repeat(), '1fr 1fr 250px'\n * @param $row-gap, $column-gap (string) - string value for grid-gap\n *\n * Example usage: buildCSSGrid('grid-template-columns', '1fr 3fr 1fr', 'md', 'sm');\n *    -> renders to: { \n                      display: grid; \n                      grid-template-columns: 1fr 3fr 1fr;\n                      row-gap: 24px;\n                      column-gap: 8px;\n                    }\n */\n.robinhood-banner {\n  width: 100%;\n  max-width: 425px;\n  background: #fffbee;\n  border-radius: 8px;\n  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.15);\n  padding: 16px;\n  margin-bottom: 16px;\n  margin-top: -20px;\n}\n.robinhood-banner__content {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.robinhood-banner__title {\n  color: var(--Secondary-Slate, #5d5d5e);\n  font-family: \"Rh-phonic\";\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n}\n.robinhood-banner__icon {\n  width: 14px;\n  height: 18px;\n  margin-left: 0;\n  vertical-align: middle;\n  position: relative;\n  top: -1px;\n}\n.robinhood-banner__gold {\n  color: #000000;\n}\n.robinhood-banner__description {\n  font-size: 14px;\n  line-height: 1.4;\n  color: #333333;\n  font-family: \"poppins\", -apple-system, BlinkMacSystemFont, sans-serif;\n  margin-top: 2px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 160%;\n  letter-spacing: -0.1px;\n}\n.robinhood-banner__highlight {\n  font-weight: 600;\n}\n.robinhood-banner__learn-more {\n  font-size: 14px;\n  font-weight: 600;\n  color: #000;\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-decoration: underline;\n  padding-left: 6px;\n}\n.robinhood-banner__learn-more:hover {\n  text-decoration: underline;\n}\n.robinhood-banner__learn-more:focus {\n  outline: none;\n}\n.robinhood-banner__arrow {\n  margin-left: 4px;\n  font-size: 18px;\n}\n\n@media (min-width: 950px) {\n  .robinhood-banner {\n    padding: 20px;\n    max-width: none;\n  }\n  .robinhood-banner__content {\n    gap: 12px;\n  }\n  .robinhood-banner__title {\n    font-size: 14px;\n    line-height: 24px;\n  }\n  .robinhood-banner__gold {\n    font-size: 14px;\n  }\n  .robinhood-banner__icon {\n    width: 16px;\n    height: 20px;\n  }\n  .robinhood-banner__description {\n    font-size: 16px;\n    letter-spacing: -0.2px;\n  }\n}\n@media (min-width: 1100px) {\n  .robinhood-banner {\n    padding: 24px;\n  }\n  .robinhood-banner__content {\n    gap: 14px;\n  }\n  .robinhood-banner__title {\n    font-size: 15px;\n  }\n  .robinhood-banner__gold {\n    font-size: 15px;\n  }\n  .robinhood-banner__description {\n    font-size: 18px;\n    line-height: 170%;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
